import React from "react";
import Modal from "react-modal";
import { useTranslation } from 'react-i18next';
import "./deleteModal.scss";

Modal.setAppElement('#root'); 

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, message, title}) => {
  const { t } = useTranslation('deleteModal');

  message = message || t('deleteMessage');
  title = title || t('deleteTitle');

  return (
    <Modal 
      isOpen={isOpen} 
      onRequestClose={onClose} 
      className="modalContent"
      overlayClassName="confirmationModalOverlay"
    >
      <h3 className="modalHeader">{t('areYouSure')}</h3>
      <p>{message}</p>
      <div className="buttonsContainer">
        <button onClick={onClose} className="modalButton">{t('cancel')}</button>
        <button onClick={onConfirm} className="modalButton">{t('confirm')}</button>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
